import React, { useRef } from 'react';
import { useFocusTrap } from '../../hooks/useFocusTrap';
import { Löschen, Abbrechen } from '../../icons';
import './DeleteConfirmModal.css';

export function DeleteConfirmModal({
  title,
  body,
  onConfirm,
  onCancel,
  loading,
  titleId = 'delete-confirm-title',
}) {
  const modalRef = useRef(null);
  useFocusTrap(true, modalRef);

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <div className="modal" ref={modalRef}>
        <h2 id={titleId}>{title}</h2>
        <div>{body}</div>
        <div className="modal-actions">
          <button className="modal-primary" onClick={onConfirm} disabled={loading}>
            {loading ? 'Löschen…' : <><Löschen /> Löschen bestätigen</>}
          </button>
          <button className="modal-secondary" onClick={onCancel} disabled={loading}>
            <Abbrechen /> Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
